// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__tbJJS","checkboxCol":"Table_checkboxCol__2omem","emailCol":"Table_emailCol__3U79E","actionCol":"Table_actionCol__1zSRl"};